<template>
  <div class="opple-ali-valiCode-btn" :style="{ color: btnColor }">
    <div
      v-if="isLoadingFrame"
      class="opple-ali-valiCode-btn-loading"
    >
      <i
        class="el-icon-loading"  
      />
    </div>
    <template
      v-else
    >
      <div
        v-if="countDown < 0"
        class="opple-ali-valiCode-btn_main"
        @click="getAliCodeVal"
      >
        {{ $t("login.getCode") }}
      </div>
      <div
        v-else
        class="opple-ali-valiCode-btn_time"
      >
        <span>{{ countDown }}</span>
        <span>s</span>
      </div>  
    </template>
    
    
    <!-- <el-button
      v-if="Verification"
      class="yanz"
      :loading="issending"
      type="text"
      @click="getAliCodeVal"
    >
      
    </el-button> -->
    <div
      v-if="isShowAliFrame"
      class="ali-val-iframe"
    >
      <iframe
        id="ali-val-iframe"
        frameborder="0"
      />
    </div>
  </div>
</template>

<script>
import { host } from '@/assets/js/api';
import { REGION_ALI_LANG, REGION_ALI_TELE } from '@/enums/region';
import { getErrorMsgByStatusCode } from '@/utils/system';
import { GetLoginConfig } from '@/axios/ICommon';

// const COUNT_DOWN_ACHE = 'OPPLE_COUNT_DOWN_ACHE';

export default {
  components: {
  
  },
  props: {
    tele: {
      type: String,
      default: ''
    },
    verifyCodeType: {
      type: String,
      default: '0'
    },
    btnColor: {
      type: String,
      default: '#e6e6e6'
    },
    cacheKey: {
      type: String,
      default: 'OPPLE_COUNT_DOWN_ACHE'
    },
  },
  data () {
    return {
      isLoadingFrame: false,
      isShowAliFrame: false,
      countDown: -1,
      countTimer: null,
      captchaConfig: {
        Identity: '',
        SceneId: ''
      },
      whiteList: [
        'http://localhost:8080',
        'https://iot-dev-cdn.opple.com',
        'https://iot-test-cdn.opple.com',
        'https://iot1-cdn.opple.com',
        'https://iot2-cdn.opple.com',
        'https://iot3-cdn.opple.com'
      ]
    }
  },
  watch: {
    
  },
  mounted () {
    this.initAche();
    this.getConfig();
    this.registMessage();
  },
  destroyed () {
    window.removeEventListener('message', this.handlerMessage)
    this.countTimer && clearInterval(this.countTimer);
  },
  created () {},
  methods: {
    getCacheKey () {
      return this.cacheKey;
    },
    getTimestampKey () {
      return `${this.cacheKey}_timestamp`;
    },
    async getConfig() {
      try {
        const res = await GetLoginConfig({
          osType: 3
        });
        
      if (res && res.Result && res.Result.CaptchaList) {
        const Captcha = res.Result.CaptchaList || [];
        const data =  Captcha.find(item => (item.Regions || []).find(r => r === 'Default'));

        this.captchaConfig = data;
      }

      } catch (e) {}

      
    },

    initAche() {
      debugger
      const lastTime = localStorage.getItem(this.getCacheKey());
      const lastTimestamp = localStorage.getItem(this.getTimestampKey());
      
      if (lastTime && lastTimestamp) {
        const pastSeconds = Math.floor((Date.now() - Number(lastTimestamp)) / 1000);
        const remainingTime = Number(lastTime) - pastSeconds;

        if (remainingTime > 0) {
          this.countDown = remainingTime;
          this.handlerCountdown();
        } else {
          localStorage.removeItem(this.getCacheKey());
          localStorage.removeItem(this.getTimestampKey());
          this.countDown = -1;
        }
      }
    },
    registMessage() {
      this.handlerMessage = event => {
        console.log('收到message 1', event);
        if (
          event && 
          this.whiteList.includes(event.origin) && 
          event.data
        ) {
            //console.log('接收到父页面消息1:', message);
            const payload = event.data?.payload || {};
            // 对消息进行处理
            switch (event.data.type) {
              // 设置token
              case  'CAPTCHA_RES':
                this && this.handlerCaptchaRes(payload);
                break;
              // case 'CAPTCHA_CLOSE':
              //   this.isLoadingFrame = false;
              //   this.isShowAliFrame = false;
              //   this.$emit('close')
              //   break;
              default:
                return;
            }
          }
        }
      window.addEventListener('message', this.handlerMessage, false);
    },

    handlerCountdown() {
      this.countTimer = setInterval(() => {
        this.countDown -= 1;
        localStorage.setItem(this.getCacheKey(), this.countDown);
        localStorage.setItem(this.getTimestampKey(), Date.now());
        if (this.countDown < 0) {
          clearInterval(this.countTimer);
          localStorage.removeItem(this.getCacheKey());
          localStorage.removeItem(this.getTimestampKey());
        }
      }, 1000);
    },


    handlerCaptchaRes(payload) {
      const { type, StatusCode, msg, Result } = payload;

      if (type === 'success') {
        this.isShowAliFrame = false;

        this.$message({
          message: this.$t('invite.span1'),
          type: 'success'
        });

        this.$emit('success')
        this.countDown = 60;
        localStorage.setItem(this.getCacheKey(), 60);
        this.handlerCountdown();
      } 
      
      if (type === 'fail') {
        this.$message({
          message: getErrorMsgByStatusCode(StatusCode, Result) || msg,
          type: 'warning'
        });

        // 滑块成功 消息失败
        // if (StatusCode === 13008) {
        //   this.isShowAliFrame = false;
        // }
        this.$emit('fail');
        localStorage.setItem(COUNT_DOWN_ACHE, -1);
        this.countDown  = -1;
      }

      if (type === 'close') {
        this.isLoadingFrame = false;
        this.isShowAliFrame = false;
        this.$emit('close')
      }
    },

    getAliCodeVal() {
      if (this.countDown > 0) return;

      const phoneRegex = /^1\d{10}$/;
      const tele = this.tele

      if (
        !phoneRegex.test(tele)
      ) {
        this.$message({
          type: "warning",
          message: this.$t('login.validPhoneNumber')
        });

        return;
      }

      this.isShowAliFrame = true;
      this.isLoadingFrame = true;

      this.$nextTick(() => {
        const iframe = document.getElementById('ali-val-iframe')
        const iframeWindow = iframe.contentWindow;
        const language = REGION_ALI_LANG[getLocalStoragItem('lang')] || 'zn';
        // console.log('ipConfig', this.$store.state.ipConfig);
        // let iframeSrc = 'http://localhost:8080';
        let iframeSrc = this.$store.state.ipConfig?.CN?.Domain?.AliyunCaptchaUrl ?
          `https://${this.$store.state.ipConfig?.CN?.Domain?.AliyunCaptchaUrl}` :
          'https://iot-dev-cdn.opple.com';

        this.whiteList.push(iframeSrc);
        // iframe.src = iframeSrc + '/captcha.html';
        iframe.src = iframeSrc + '/h5_login_captcha/index.html';

        const $host = process?.env?.NODE_ENV === 'development' ? 'https://iot-dev.opple.com' : host;

        iframe.onload = () => {
          console.log('iframe 加载完毕');
          const payload = {
            captchaUrl: `${$host}/baseservice/Common/CaptchaVerify`,
            captchaInitParam: {
              SceneId: this.captchaConfig.SceneId, // '2n1i1xf6',
              prefix: this.captchaConfig.Identity, // 'hrt068', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
              language,
              region: this.$store.state.region, //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
              ClientId: 'opple_business_light'
            },
            captchaUrlParams: {
              phoneNumber: tele,
              countryCode: REGION_ALI_TELE[this.$store.state.region],
              verifyCodeType: this.verifyCodeType,
              sceneId: this.captchaConfig.SceneId
              // OSType: 'Web'
            },
            parentOrigin: window.origin
          }
          console.log('REGION_ALI_TELE', REGION_ALI_TELE, REGION_ALI_TELE[this.$store.state.region]);

          iframeWindow.postMessage({ 
            type: 'SET_INIT_DATA', 
            payload, 
            result: false
          }, iframeSrc)

          setTimeout(() => {
            this.isLoadingFrame = false;
          }, 1000)
        };

        iframe.onerror = (err) => {
          console.log('err!!!!!!!!!', err);
          this.isLoadingFrame = false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.el-icon-loading {
  font-size: 12px;
  margin: 0 !important;
}
.opple-ali-valiCode-btn {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &_main {
    cursor: pointer;
  }
}
.ali-val-iframe {
  position: absolute;
  width: 321px;
  height: 350px;
  right: 0;
  top: 43px;
  z-index: 99;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
